import BaseModel from "./base/baseModel";

export default class ComissaoPrescritorFaixaModel extends BaseModel {
    id?: number = null;
    prescritorId? : number = null;
    inicioFaixa? : number = null;
    fimFaixa? : number = null;
    porcentagemComissao? : number = null;
}